import styled from '@emotion/styled'
import { breakpoint, calcRem } from '../../../__styling'
import { AppDownloadSection } from '../../components/StyledAppDownloadSection.styled'
import { AppContentSection } from '../../components/StyledAppContentSection.styled'
import { InnerAppDownloadTextSection } from '../../components/StyledAppDownloadSection.styled'
import { TheNightlyHorizontalLogo } from '../../../logos/TheNightlyLogo/TheNightlyHorizontalLogo'
import { tokens } from '@news-mono/design-tokens'

export const StyledAppDownloadSectionTop = styled(AppDownloadSection)({
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '0px',
    justifyContent: 'center',
})

export const AppDownloadButtonsSection = styled('div')({
    width: '100%',
    height: 'fit-content',
    gap: calcRem(8),
    display: 'flex',
    justifyContent: 'center',
})

export const InnerAppDownloadTextSectionTop = styled(
    InnerAppDownloadTextSection,
)({
    width: '100%',
    gap: calcRem(8),
    textAlign: 'center',

    [breakpoint('sm')]: {
        width: '100%',
        gap: calcRem(24),
    },
})

export const AppDownloadContentSectionTop = styled(AppContentSection)({
    display: 'flex',

    width: '100%',
    gap: calcRem(24),
    padding: '0px',

    [breakpoint('sm')]: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    },

    [breakpoint('lg')]: {
        padding: '0px',
    },
})

export const StyledTNLogo = styled(TheNightlyHorizontalLogo)({
    width: '100%',
    height: calcRem(32),
})

export const StyledQRCodeContainer = styled('div')({
    display: 'none',
    [breakpoint('sm')]: {
        display: 'flex',
        justifyContent: 'center',
    },
})

export const StyledAppDownloadTitle = styled('h2')(({ theme }) => ({
    color: theme.colors.text.heading,
    fontFamily: theme.fonts.heading,
    fontWeight: 600,

    margin: 0,
    paddingBottom: calcRem(8),

    // Smaller text styling for mobile devices
    fontSize: calcRem(32),
    lineHeight: calcRem(38.4),
    letterSpacing: calcRem(-0.96),

    // Laptop and larger devices have larger text than the mobile versions
    [breakpoint('sm')]: {
        fontSize: calcRem(40),
        lineHeight: calcRem(48),
        letterSpacing: calcRem(-1.2),
        paddingBottom: calcRem(24),
    },
}))

export const StyledAppDownloadSubText = styled('p')(({ theme }) => ({
    color: tokens.thenightly.colors.palette.neutral[70],
    fontFamily: theme.fonts.sansSerif,
    fontSize: calcRem(16),
    fontWeight: 400,
    lineHeight: calcRem(24),
    letterSpacing: calcRem(-0.32),

    margin: 0,
    padding: 0,
}))
